let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1FvU5")).then(() => parcelRequire('4AltF'));